import { chunk } from 'lodash-es';
import data from './data';
import {Check} from "lucide-react";
import miniImage from '~/images/services/mini.jpeg';


const Features = () => {
  const [left, right] = chunk(data, 3);

  return (
    <div className="container mx-auto py-32">
      <div className="w-full flex flex-wrap items-center">
        <div className="w-full lg:w-1/3 flex flex-col space-y-8 pb-16 lg:pb-0">
          { left.map((item, i) => (
            <Feature
              key={`feature-left-item-${i}`}
              title={item.title}
              text={item.text}
            />
          ))}
        </div>

        <div className="w-full lg:w-1/3 flex justify-center px-16 lg:px-0">
          <img src={miniImage} width={340} height={700} alt='Воздушный шар фигура Мини Микки' />
        </div>

        <div className="f-full lg:w-1/3 flex flex-col space-y-8 pt-16 lg:pt-0">
          { right.map((item, i) => (
            <Feature
              key={`feature-right-item-${i}`}
              title={item.title}
              text={item.text}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Features


const Feature = ({ title, text }) => (
  <div className="flex mx-4 lg:mx-0 mb-4">
    <div className="flex flex-col justify-center w-16">
      <div className='w-16 h-16 rounded-full bg-brand-blue font-bold text-xl flex justify-center items-center'>
        <Check />
      </div>
    </div>
    <div className="flex-grow pl-8">
      {/* <h3 className='text-2xl font-bold mb-4'>{title}</h3> */}
      <p className="text-xl md:text-2xl leading-relaxed">
        {title}
      </p>
    </div>
  </div>
)